import Button from '@components/_elements/Button/Button';
import Popup from '@components/_elements/Popup/Popup';
import { useRdgToggleMutation } from '@hooks/api/mutations/useRdgMutation';
import { Actions } from '@src/types/Actions';
import storeConnector from '@store/storeConnector';
import { useTranslation } from 'react-i18next';
import FormattedAlias from '../_shared/Translations/FormattedAlias';

interface ToggleRDGPopupProps {
  actions: Actions;
  isOpen: boolean;
  close: () => void;
}

function ToggleRDGPopup({ actions, isOpen, close }: ToggleRDGPopupProps) {
  const { t } = useTranslation();
  const rdgToggleMutation = useRdgToggleMutation();

  const toggleRdg = (enabled: boolean) => {
    rdgToggleMutation.mutate(
      { enabled },
      {
        onSuccess: (res) => {
          if (res?.success) {
            if (enabled) {
              actions.notify(`RDG turned ON - ${res.message}`);
            } else {
              actions.notifyError(`RDG turned OFF`);
            }
          } else {
            actions.notifyError(res?.message || 'Failed to toggle RDG');
          }
          close();
        },
        onError: () => {
          actions.notifyError('Failed to toggle RDG');
          close();
        },
      },
    );
  };

  return (
    <Popup
      isOpen={isOpen}
      title={t('CONFIRM_EXECUTION_QUESTION')}
      close={() => close()}
      bodyClass='content-popup'
    >
      <div style={{ margin: '20px' }}>Toggle Random Data Generator</div>
      <div className='btn-row'>
        <Button
          onClick={() => toggleRdg(true)}
          size='m'
          disabled={rdgToggleMutation.isPending}
        >
          <FormattedAlias id={'ON'} />
        </Button>
        <Button
          onClick={() => toggleRdg(false)}
          size='m'
          disabled={rdgToggleMutation.isPending}
        >
          <FormattedAlias id={'OFF'} />
        </Button>
      </div>
    </Popup>
  );
}

export default storeConnector(ToggleRDGPopup, {
  config: ['siteMeta'],
});
